// 企业版子账号相关
import { httpCreate } from './http';
const http = httpCreate('/srv/saas');

export const saas = {
	// 获取可切换的门店
	getPhystoreList() {
		return http.get('/company/senior/phy-store-join');
	},
	/*******  登录相关   ********/
	// 获取已选择的企业信息
	getCompanyInfo(params) {
		return http.get('/company/senior/companyInfo', { params, ttl: 1000 });
	},
	// 根据域名取当前企业Id
	getDomainCompanyId() {
		return http.get('/company-domain/getCompanyId');
	},
	// 根据专辑id获取当前企业绑的独立域名
	getCompanyDomainByGatherId(gatherId) {
		return http.get(`/company-domain/gather/${gatherId}`);
	},
	// 选择企业
	/**
	 * @param { Number } params.companyId 企业id
	 * @returns
	 */
	changeCompany(params) {
		return http.get('/company/senior/changCompany', { params });
	},
	// 获取我加入的企业列表
	getJoinCompanyList(params) {
		return http.get('/company/senior/company-join', { params });
	},
	// 获取企业设定域名
	/**
	 * @param { Number } userId 企业信息中的userId，不是本地登录的userId
	 */
	getCompanyDomain(userId) {
		return http.get(`/company-domain/user/${userId}`, { ttl: 1000 });
	},

	/*******  直播间相关   ********/
	// 根据直播间id获取当前企业绑的独立域名
	getCompanyDomainByActivityId(activityId) {
		return http.get(`/company-domain/activity/${activityId}`);
	},

	/*******  子账号相关   ********/
	// 新增子账号
	/**
	 * @param { Number } companyId 企业id
	 * @param { Object } data 暂时无数据，置空即可
	 * @param { String } params.mobPhone   子账号手机号
	 * @param { Number } params.isCreateActivity  创建直播间权限 0否，1是
	 * @returns
	 */
	addSubAccount(companyId, data, params) {
		return http.post(`/subAccount/senior/add/${companyId}`, data, { params });
	},
	// 获取子账号列表
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } params.page 是否分野 1分页，其他不分页
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @param { Number } params.orderBy 排序 0-时间正序， 1-时间倒序
	 * @param { Number } params.status
	 * @param { String } params.keyWord
	 * @returns
	 */
	getSubAccountList(companyId, params) {
		return http.get(`/subAccount/senior/accounts/${companyId}`, { params });
	},
	// 打开/关闭(创建直播间权限)
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } subAccountId 子账号id
	 * @param { Number } data.isCreateActivity 创建直播间权限 0否，1是
	 */
	createActivityOnOff(companyId, subAccountId, data) {
		return http.put(`/subAccount/senior/onOff/${companyId}/${subAccountId}`, data);
	},
	// 删除子账号
	/**
	 * @param { Number } companyId 企业id
	 * @param { Array } subAccloutIdList 子账号id数组
	 * @returns
	 */
	deleteSubAccounts(companyId, subAccloutIdList) {
		return http.delete(`subAccount/senior/delete/${companyId}`, { data: subAccloutIdList });
	},
	// 子账号授权开启/禁用
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } subAccountId 子账号id
	 * @param { Number } data.status 授权是否有效（0-禁用，1-开启）
	 */
	subAccountOpenOrClose(companyId, subAccountId, data) {
		return http.put(`/subAccount/senior/openOrClose/${companyId}/${subAccountId}`, data);
	},

	/*******  企业相关   ********/
	// 获取指定企业信息
	/**
	 * @param { Number } subAccountId 子账号id
	 * @param { Object } params 为空，暂时使用该字段
	 */
	getCompanyInfoForId(companyId, params) {
		return http.get(`/company/senior/${companyId}`, { params });
	},
	// 修改企业信息
	/** 请求示例
	 * @param { Number } companyId 企业id
	 * @param { String } data.webDomain 示例："ourwill.tuwenzhibo.com",
	 * @param { String } data.webName 示例："网站名称",
	 * @param { String } data.webIcon 示例："fileInfo:52506:4f680bf930905bbbfe8592dddc0a236e",
	 * @param { String } data.webLogo 示例："fileInfo:52506:c201da129fecf4f612e304895f039aff",
	 * @param { String } data.loading 示例："fileInfo:52506:00c8026140d4423171b3bb2bf1f5c2a6",
	 * @param { Number } data.isSsl 示例：1,
	 * @param { Number } data.baiduBusiness 示例：1,
	 * @param { String } data.baiduBusinessCode 示例："xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
	 * @param { String } data.templateId 示例："templateIdxxxxxxxxxxx"
	 * @returns
	 */
	updateCompanyInfo(companyId, data) {
		return http.put(`/company/senior/${companyId}`, data);
	},

	/*******  高级设置相关   ********/
	// 获取服务接入开光详情
	getServiceStatus(params) {
		return http.get('/company/senior/serviceStatus', { params });
	},
	// 服务接入开关
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } serviceStatus 0 关闭 1 开启
	 * @returns
	 */
	serviceSwitch(companyId, serviceStatus) {
		// path参数 companyId 去掉 -- 独立商户改版
		return http.post(`/company/senior/service-status/${serviceStatus}`);
	},
	// 获取企业域名信息
	/**
	 * @param { Number } companyId 企业id
	 * @returns
	 */
	getDomainAccountInfo(companyId) {
		return http.get(`/company-domain/${companyId}`);
	},
	// 保存域名信息
	/**
	 * @param { Number } companyId  企业id
	 * @param { Boolean } data.is_active 是否生效 默认否
	 * @param { String } data.domainName 域名
	 * @param { String } data.cert 域名ssl证书
	 * @param { String } data.certKey 域名ssl证书私钥
	 * @returns
	 */
	saveDomainAccountInfo(companyId, data) {
		return http.post(`/company-domain/${companyId}`, data);
	},
	// 申请免费证书并切换
	/**
	 * @param { Number } companyId  企业id
	 * @param { String } params.domainName  域名 系统已有的话可以不填
	 */
	applyFreeCertificate(companyId, params) {
		return http.post(`/company-domain/generate-cert/${companyId}`, params);
	},
	// 获取公众号信息
	getOfficialAccountInfo() {
		return http.get('/official-account');
	},
	// 保存公众号信息
	/**
	 * @param { Number } officialId  公众号记录id
	 * @param { Number } photoLive 平台 0 直播 1 云摄影
	 * @param { String } data.appSecret 公众号密钥
	 * @param { String } data.configMark 配置标记 0 否 1 是， 按顺序为 ip,业务域名,js域名,授权域名
	 * @returns
	 */
	saveOfficialAccountInfo(data) {
		return http.post('/official-account', data);
	},
	// 上传域名校验文件
	/**
	 * @param { File } file 域名校验文件
	 * @returns
	 */
	uploadOfficialFile(file) {
		return http.post('/official-account/upload/', file);
	},
	// 获取商户信息
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } photoLive 平台 0 直播 1 云摄影
	 * @returns
	 */
	getOfficialAccountPayInfo(companyId, photoLive) {
		// 商户配置把path参数 companyId 去掉 -- 独立商户改版
		return http.get('/official-pay-account');
	},
	// 修改商户信息
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } photoLive 平台 0 直播 1 云摄影
	 * @param { Boolean } data.isActive 是否生效 默认false
	 * @param { NUmber } data.payMchId 商户号 id
	 * @param { String } data.payMchName 商户名称
	 * @param { String } data.payPartnerKey 商户API密钥
	 * @returns
	 */
	updateOfficialPayInfo(companyId, photoLive, data) {
		// 商户配置把path参数 companyId 去掉 -- 独立商户改版
		return http.post('/official-pay-account', data);
	},
	// 上传商户支付证书
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } photoLive 平台 0 直播 1 云摄影
	 * @param { File } file p12证书
	 * @returns
	 */
	uploadOfficialPayFile(companyId, photoLive, file) {
		// 商户配置把path参数 companyId 去掉 -- 独立商户改版
		return http.post('/official-pay-account/upload', file);
	},
	// 上传商户API私钥
	uploadingKey(photoLive, file) {
		return http.post('/official-pay-account/uploadPrivateCert', file);
	},
	// 上传商户API公钥
	uploadPublicCert(photoLive, file) {
		return http.post('/official-pay-account/uploadPublicCert', file);
	},

	appletAccount(body) {
		return http.post('/appletAccount', body);
	},
	getAppletAccount() {
		return http.get('/appletAccount');
	},
	getSubAccountNameList(companyId) {
		return http.get(`/subAccount/nameList/${companyId}`);
	},
	/**
	 * @param { Number } companyId 企业id
	 * @param { Number } id 子账号id
	 * @param { Number } isAlone 0 取消独立管理 1 设为独立管理
	 * @returns
	 */
	aloneStatus(companyId, id, isAlone) {
		return http.put(`/subAccount/senior/aloneStatus/${companyId}/${id}/${isAlone}`);
	},
};
